import { useZoom } from "@/hooks/use-zoom";

export function ZoomControl() {
  const { current, zoomIn, zoomOut, isMin, isMax } = useZoom();

  const btnStyle = (disabled: boolean): React.CSSProperties => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "0.25rem",
    border: "1px solid hsl(var(--sidebar-border))",
    background: "none",
    color: disabled
      ? "hsl(var(--sidebar-foreground) / 0.25)"
      : "hsl(var(--sidebar-foreground) / 0.6)",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: "0.875rem",
    lineHeight: 1,
    padding: 0,
    flexShrink: 0,
    transition: "background 0.15s, color 0.15s",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.375rem",
        padding: "0.375rem 0.75rem",
      }}
    >
      <button
        onClick={zoomOut}
        disabled={isMin}
        aria-label="Zoom out"
        style={btnStyle(isMin)}
        onMouseEnter={(e) => {
          if (!isMin) (e.currentTarget as HTMLButtonElement).style.background = "hsl(var(--sidebar-accent) / 0.4)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "none";
        }}
      >
        −
      </button>

      <span
        style={{
          fontSize: "0.6875rem",
          color: "hsl(var(--sidebar-foreground) / 0.45)",
          fontVariantNumeric: "tabular-nums",
          border: "1px solid hsl(var(--sidebar-border))",
          borderRadius: "0.25rem",
          padding: "0.125rem 0.375rem",
          minWidth: "3.5rem",
          textAlign: "center",
          lineHeight: 1.4,
        }}
      >
        {current}
      </span>

      <button
        onClick={zoomIn}
        disabled={isMax}
        aria-label="Zoom in"
        style={btnStyle(isMax)}
        onMouseEnter={(e) => {
          if (!isMax) (e.currentTarget as HTMLButtonElement).style.background = "hsl(var(--sidebar-accent) / 0.4)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "none";
        }}
      >
        +
      </button>
    </div>
  );
}
